// ============================================================
// MHC BUY BOX — Option 1A (spec-aligned)
// ============================================================
(function () {
  'use strict';

  // ── Viewport lock + horizontal overflow guard (site-wide) ───
  // Pins the layout viewport at device width so mobile can't zoom the
  // page out into a right-side gap, and clips any stray horizontal
  // overflow. Note: iOS Safari still permits pinch-zoom by accessibility
  // policy; this stops layout/auto zoom and locks Android fully.
  (function lockViewport() {
    var content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no, viewport-fit=cover';
    var meta = document.querySelector('meta[name="viewport"]');
    if (meta) {
      meta.setAttribute('content', content);
    } else {
      meta = document.createElement('meta');
      meta.name = 'viewport';
      meta.content = content;
      document.head.appendChild(meta);
    }
    var style = document.createElement('style');
    style.textContent = 'html, body { max-width: 100vw !important; overflow-x: clip !important; }';
    document.head.appendChild(style);
  })();

  // ── Fit blurb copy (per README spec) ─────────────────────
  var FIT_BLURBS = {
    'all':       'Every colorway across all three fits — pick a fit to narrow it down.',
    'flat bill': 'High, structured crown with a stiff flat brim — sits above the brow, boxy profile.',
    'flatbill':  'High, structured crown with a stiff flat brim — sits above the brow, boxy profile.',
    '7 panel':   'Seven-panel build with a taller front and slight curve — roomier through the crown.',
    'retro':     'Low, softer crown with a pre-curved brim — the broken-in, everyday shape.',
    'trucker':   'Mesh-back construction with a structured front panel — breathable and classic.',
    'fitted':    'Clean fitted crown with no adjustable closure — structured all the way around.',
    'grandpa':   'Unstructured six-panel with a curved brim — relaxed, broken-in feel.'
  };

  // ── Helpers ──────────────────────────────────────

  function getMHCSelectedVariant() {
    var picker = document.querySelector('[data-mh-variant-picker]');
    if (!picker) return null;
    var el = picker.querySelector('[data-mh-variants-json]');
    if (!el) return null;
    try {
      var variants = JSON.parse(el.textContent || '[]');
      var idInput =
        document.querySelector('form[action*="/cart/add"] input[name="id"]') ||
        document.querySelector('product-form input[name="id"]') ||
        document.querySelector('input[name="id"]');
      if (idInput && idInput.value) {
        var byId = variants.find(function (v) { return String(v.id) === String(idInput.value); });
        if (byId) return byId;
      }
      return variants[0] || null;
    } catch (e) { return null; }
  }

  function formatPrice(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
    }).format(cents / 100);
  }

  function formatColorName(rawName) {
    var prefixes = ['Flat Bill', 'Flatbill', '7 Panel', 'Retro', 'Trucker', 'Fitted', 'Grandpa'];
    for (var i = 0; i < prefixes.length; i++) {
      if (rawName.indexOf(prefixes[i]) === 0) {
        var rest = rawName.slice(prefixes[i].length).replace(/^\s+/, '');
        if (rest) return prefixes[i] + ' · ' + rest;
        return rawName;
      }
    }
    return rawName;
  }

  // ── Mobile: in-panel title + price ─────────────────────
  // The old above-photo mobile title section is retired. A cascade-layer
  // !important rule hides the in-panel title/price on mobile, and layered
  // importants beat any stylesheet override — only inline importants win.
  // Forcing them visible gives mobile the same title/price row as desktop.

  var mhMobileTitleMQ = window.matchMedia('(max-width: 749px)');

  function syncMobileTitlePrice() {
    var els = [
      document.querySelector('.product-details h1.mh-hide-original-mobile-title'),
      document.querySelector('product-price .price')
    ];
    var on = mhMobileTitleMQ.matches;
    els.forEach(function (el) {
      if (!el) return;
      if (on) {
        el.style.setProperty('display', 'block', 'important');
      } else {
        el.style.removeProperty('display');
      }
    });
  }

  // ── Section labels: 01 — FIT / 02 — COLOR ────────────────

  function initBuyBoxLabels() {
    var fitWrap = document.querySelector('.mh--wrap');
    if (fitWrap) {
      var prev = fitWrap.previousElementSibling;
      if (!prev || !prev.classList.contains('mh-opt-label')) {
        var fitLabel = document.createElement('div');
        fitLabel.className = 'mh-opt-label mh-opt-label--fit';
        fitLabel.innerHTML =
          '<span class="mh-opt-label__text">01 — FIT</span>' +
          '<span class="mh-opt-label__meta" id="mh-fit-count"></span>';
        fitWrap.parentNode.insertBefore(fitLabel, fitWrap);
      }
    }

    var swatchFieldset = document.querySelector('.madhatter-variant-picker .variant-option--swatches');
    if (swatchFieldset) {
      // Insert the color label OUTSIDE <variant-picker> (as its previous
      // sibling) — Horizon morphs variant-picker's inner DOM on variant
      // change, which used to wipe the label and cause a visible flash.
      var vpEl = swatchFieldset.closest('variant-picker');
      var anchor = vpEl || swatchFieldset;
      var prev2 = anchor.previousElementSibling;
      if (!prev2 || !prev2.classList.contains('mh-opt-label--color')) {
        // Migrate any stray copy that older code left inside variant-picker
        var stray = document.querySelector('.madhatter-variant-picker .mh-opt-label--color');
        if (stray) stray.remove();
        var colorLabel = document.createElement('div');
        colorLabel.className = 'mh-opt-label mh-opt-label--color';
        colorLabel.innerHTML =
          '<span class="mh-opt-label__text">02 — COLOR</span>' +
          '<span class="mh-opt-label__meta" id="mh-color-name"></span>';
        anchor.parentNode.insertBefore(colorLabel, anchor);
      }
      var swatchLegend = swatchFieldset.querySelector('legend');
      if (swatchLegend) swatchLegend.style.display = 'none';
      swatchFieldset.querySelectorAll('[class*="header"], [class*="label-header"]').forEach(function (el) {
        el.style.display = 'none';
      });
    }

    syncMobileTitlePrice();
  }

  function updateBuyBoxLabelDetails() {
    var fitCountEl = document.getElementById('mh-fit-count');
    if (fitCountEl) {
      var visible = document.querySelectorAll('.variant-option__button-label--has-swatch:not(.mh-fit-hidden-option)');
      var count = visible.length;
      var activePill = document.querySelector('.mh-fit-pill--active');
      var fitName = activePill ? activePill.textContent.trim() : 'All';
      var isAll = fitName.toLowerCase() === 'all';
      fitCountEl.textContent =
        count + ' color' + (count !== 1 ? 's' : '') +
        (isAll ? ', all fits' : ', ' + fitName.toLowerCase() + ' fit');
    }

    var colorNameEl = document.getElementById('mh-color-name');
    if (colorNameEl) {
      var variant = getMHCSelectedVariant();
      if (variant && variant.title) {
        colorNameEl.textContent = formatColorName(variant.title);
      }
    }
  }

  // ── Fit blurb ─────────────────────────────────────

  function initFitBlurb() {
    if (document.querySelector('.mh-fit-blurb')) return;
    var fitWrap = document.querySelector('.mh--wrap');
    if (!fitWrap) return;
    var blurb = document.createElement('div');
    blurb.className = 'mh-fit-blurb';
    blurb.textContent = FIT_BLURBS['all'];
    fitWrap.parentNode.insertBefore(blurb, fitWrap.nextSibling);
  }

  function updateFitBlurb() {
    var blurb = document.querySelector('.mh-fit-blurb');
    if (!blurb) { initFitBlurb(); blurb = document.querySelector('.mh-fit-blurb'); }
    if (!blurb) return;
    var activePill = document.querySelector('.mh-fit-pill--active');
    var fitKey = activePill ? activePill.textContent.trim().toLowerCase() : 'all';
    blurb.textContent = FIT_BLURBS[fitKey] || FIT_BLURBS['all'];
  }

  // ── CTA: "ADD TO BAG — $XX.XX" ──────────────────────

  function patchCTAText() {
    var variant = getMHCSelectedVariant();
    var buttons = document.querySelectorAll('.mh-add-button');
    buttons.forEach(function (btn) {
      if (btn.classList.contains('mh-add-button-sold-out')) return;
      if (btn.classList.contains('mh-add-button-added')) return;
      if (!variant || !variant.available) return;

      var priceStr = formatPrice(variant.price);
      var newText = 'ADD TO BAG — ' + priceStr;

      // Patch MHC's saved original so its restoreButtonText() uses our format
      btn.dataset.mhOriginalText = newText;

      var target =
        btn.querySelector('[data-add-to-cart-text]') ||
        btn.querySelector('.button__text') ||
        btn.querySelector('.add-to-cart-text__content > span:first-child') ||
        btn.querySelector('.add-to-cart-text__content') ||
        btn.querySelector('span') ||
        btn;

      // Always overwrite — no conditional guard
      if (target) target.textContent = newText;
    });
  }

  // The theme rewrites the CTA label after variant changes and morphs,
  // which erased the "— $XX.XX" suffix and caused a visible blink. The
  // observer below patches SYNCHRONOUSLY: MutationObserver callbacks run
  // as microtasks before the next paint, so the un-priced text is never
  // rendered. A 200ms follow-up corrects the price if the button text
  // mutated before the form's variant id input did.
  function watchCTAButtons() {
    document.querySelectorAll('.mh-add-button').forEach(function (btn) {
      if (btn.dataset.mhCtaWatched !== 'true') {
        btn.dataset.mhCtaWatched = 'true';
        var t;
        new MutationObserver(function () {
          if (btn.classList.contains('mh-add-button-added')) return;
          if (btn.classList.contains('mh-add-button-sold-out')) return;
          var text = btn.textContent || '';
          if (text.indexOf('$') === -1) {
            patchCTAText();
            window.clearTimeout(t);
            t = window.setTimeout(patchCTAText, 200);
          }
        }).observe(btn, { childList: true, subtree: true, characterData: true });
      }

      // If a morph swaps the button node itself, re-arm on the new node and
      // patch in the same tick so nothing un-priced gets painted.
      var host = btn.parentElement;
      if (host && host.dataset.mhCtaHostWatched !== 'true') {
        host.dataset.mhCtaHostWatched = 'true';
        new MutationObserver(function () {
          patchCTAText();
          watchCTAButtons();
        }).observe(host, { childList: true });
      }
    });
  }

  function initCTAFormat() {
    function schedPatch(delay) {
      window.setTimeout(patchCTAText, delay || 320);
    }

    document.addEventListener('variant:change', function () { schedPatch(); });
    document.addEventListener('product:variant-change', function () { schedPatch(); });
    document.addEventListener('change', function (e) {
      if (e.target && e.target.type === 'radio') schedPatch();
    });

    schedPatch(400);

    // Arm the anti-blink watcher now and re-arm periodically as a backstop.
    window.setTimeout(watchCTAButtons, 500);
    window.setInterval(watchCTAButtons, 3000);

    document.addEventListener('cart:updated', function () {
      var btn = document.querySelector('.mh-add-button:not(.mh-add-button-sold-out)');
      if (!btn) return;
      var target =
        btn.querySelector('[data-add-to-cart-text]') ||
        btn.querySelector('.button__text') ||
        btn.querySelector('.add-to-cart-text__content > span:first-child') ||
        btn.querySelector('.add-to-cart-text__content') ||
        btn.querySelector('span') ||
        btn;
      btn.classList.add('mh-add-button-added');
      if (target) target.textContent = 'ADDED TO BAG ✓';
      window.setTimeout(function () {
        btn.classList.remove('mh-add-button-added');
        patchCTAText();
      }, 2000);
    });
  }

  // ── Stock Signal ──────────────────────────────────

  var mhSignalEl = null;

  function getOrCreateSignal() {
    if (mhSignalEl && document.body.contains(mhSignalEl)) return mhSignalEl;

    var anchor =
      document.querySelector('product-form') ||
      document.querySelector('form[action*="/cart/add"]');
    if (!anchor) return null;

    mhSignalEl = document.createElement('div');
    mhSignalEl.className = 'mh-stock-signal';

    var dot = document.createElement('span');
    dot.className = 'mh-stock-signal__dot';

    var txt = document.createElement('span');
    txt.className = 'mh-stock-signal__text';
    txt.textContent = 'In stock · ships in 3–5 business days';

    mhSignalEl.appendChild(dot);
    mhSignalEl.appendChild(txt);
    anchor.parentNode.insertBefore(mhSignalEl, anchor);
    return mhSignalEl;
  }

  function updateStockSignal() {
    var el = getOrCreateSignal();
    if (!el) return;
    var variant = getMHCSelectedVariant();
    var txt = el.querySelector('.mh-stock-signal__text');

    el.classList.remove('mh-stock-signal--out', 'mh-stock-signal--low');

    if (!variant) return;

    if (!variant.available) {
      el.classList.add('mh-stock-signal--out');
      if (txt) txt.textContent = 'Sold out — restocking soon';
    } else {
      var qty = typeof variant.inventory_quantity === 'number' ? variant.inventory_quantity : Infinity;
      if (qty > 0 && qty <= 4) {
        el.classList.add('mh-stock-signal--low');
        if (txt) txt.textContent = 'Only ' + qty + ' left in this colorway';
      } else {
        if (txt) txt.textContent = 'In stock · ships in 3–5 business days';
      }
    }
  }

  function initStockSignal() {
    document.addEventListener('variant:change', function () { window.setTimeout(updateStockSignal, 120); });
    document.addEventListener('product:variant-change', function () { window.setTimeout(updateStockSignal, 120); });
    document.addEventListener('change', function (e) {
      if (e.target && e.target.type === 'radio') window.setTimeout(updateStockSignal, 120);
    });
    window.setTimeout(updateStockSignal, 450);
  }

  // ── Free shipping / returns ───────────────────────────

  function initFreeShipping() {
    if (document.querySelector('.mh-free-shipping')) return;
    var buyButtons =
      document.querySelector('buy-buttons') ||
      document.querySelector('.product-form__buttons') ||
      document.querySelector('form[action*="/cart/add"]');
    if (!buyButtons) return;
    var line = document.createElement('div');
    line.className = 'mh-free-shipping';
    line.textContent = 'Free shipping over $75 · 30-day returns';
    buyButtons.parentNode.insertBefore(line, buyButtons.nextSibling);
  }

  // ── Boot ───────────────────────────────────────

  function bootBuyBox() {
    var labelAttempts = 0;

    function tryLabels() {
      initBuyBoxLabels();
      if (!document.querySelector('.mh-opt-label') && labelAttempts < 5) {
        labelAttempts++;
        window.setTimeout(tryLabels, 150);
      } else {
        window.setTimeout(function () {
          updateBuyBoxLabelDetails();
          initFitBlurb();
          updateFitBlurb();
        }, 420);
      }
    }

    window.setTimeout(tryLabels, 120);
    initCTAFormat();
    initStockSignal();
    window.setTimeout(initFreeShipping, 450);

    // Mobile title/price + keep it synced across breakpoint changes
    window.setTimeout(syncMobileTitlePrice, 200);
    if (mhMobileTitleMQ.addEventListener) {
      mhMobileTitleMQ.addEventListener('change', syncMobileTitlePrice);
    }

    // Re-run on variant/radio changes
    document.addEventListener('variant:change', function () {
      window.setTimeout(updateBuyBoxLabelDetails, 150);
    });
    document.addEventListener('product:variant-change', function () {
      window.setTimeout(updateBuyBoxLabelDetails, 150);
    });
    document.addEventListener('change', function (e) {
      if (e.target && e.target.type === 'radio') window.setTimeout(updateBuyBoxLabelDetails, 150);
    });

    // Watch fit pill class changes for count + blurb updates
    window.setTimeout(function () {
      var filter = document.querySelector('.mh-');
      if (!filter) return;
      var obs = new MutationObserver(function () {
        window.setTimeout(function () {
          updateBuyBoxLabelDetails();
          updateFitBlurb();
        }, 80);
      });
      filter.querySelectorAll('.mh-fit-pill').forEach(function (pill) {
        obs.observe(pill, { attributes: true, attributeFilter: ['class'] });
      });
    }, 300);

    // Safety net: if a morph ever does remove injected nodes (labels live
    // outside variant-picker now, so normally they survive), re-init fast.
    // Also re-applies the mobile title/price inline styles after morphs.
    window.setTimeout(function () {
      var vp = document.querySelector('.madhatter-variant-picker') ||
               document.querySelector('[data-mh-variant-picker]');
      if (!vp) return;
      var morphT;
      new MutationObserver(function () {
        window.clearTimeout(morphT);
        morphT = window.setTimeout(function () {
          initBuyBoxLabels();
          updateBuyBoxLabelDetails();
          initFitBlurb();
          updateFitBlurb();
        }, 60);
      }).observe(vp, { childList: true, subtree: true });
    }, 600);

    // The price span lives inside product-price, which Horizon re-renders
    // on variant changes — re-force visibility when its subtree mutates.
    window.setTimeout(function () {
      var pp = document.querySelector('product-price');
      if (!pp || pp.dataset.mhMobileSyncWatched === 'true') return;
      pp.dataset.mhMobileSyncWatched = 'true';
      new MutationObserver(function () { syncMobileTitlePrice(); })
        .observe(pp, { childList: true, subtree: true });
    }, 600);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootBuyBox);
  } else {
    bootBuyBox();
  }

  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(bootBuyBox, 100);
  });

})();